import { render } from "./MonthlyIncome.vue?vue&type=template&id=1b397f57&scoped=true"
import script from "./MonthlyIncome.vue?vue&type=script&lang=js"
export * from "./MonthlyIncome.vue?vue&type=script&lang=js"

import "./MonthlyIncome.vue?vue&type=style&index=0&id=1b397f57&scoped=true&lang=css"

import exportComponent from "E:\\NC\\services\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b397f57"]])

export default __exports__